import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonSearchbar } from '@ionic/angular/standalone';

@Component({
  selector: 'search-bar',
  templateUrl: './search-bar.component.html',
  styleUrls: ['./search-bar.component.scss'],
  standalone: true,
  imports: [CommonModule, FormsModule, IonSearchbar],
})
export class SearchBarComponent {
  @Input() placeholder = 'Search';
  @Input() value = '';
  @Output() valueChange = new EventEmitter<string>();
  @Output() search = new EventEmitter<string>();

  onValueChange(value: string) {
    this.value = value ?? '';
    this.valueChange.emit(this.value);
  }

  onSearch() {
    this.search.emit(this.value?.trim() ?? '');
  }

  onClear() {
    this.value = '';
    this.valueChange.emit(this.value);
    this.search.emit('');
  }
}
